/* 🤖 this file was generated by svg-to-ts */
export const matIconVrpano: {
  name: 'vrpano';
  data: string;
} = {
  name: 'vrpano',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21.01 4C20.45 4 17.4 5.5 12 5.5c-5.31 0-8.49-1.49-9.01-1.49-.53 0-.99.44-.99 1.01V19c0 .57.46 1 .99 1 .57 0 3.55-1.5 9.01-1.5 5.42 0 8.44 1.5 9.01 1.5.53 0 .99-.43.99-1V5c0-.57-.46-1-.99-1zM20 17.63c-2.01-.59-4.62-1.13-8-1.13-3.39 0-5.99.54-8 1.13V6.38c2.58.73 5.32 1.12 8 1.12 3.38 0 5.99-.54 8-1.13v11.26z"/><path d="m9.17 10.99-3.69 4.42c2-.26 4.18-.41 6.52-.41 2.3 0 4.52.15 6.51.4L14 10l-2.83 3.39-2-2.4z"/></svg>`
};
